/* Ḥiṣn al-Muslim — loaded on demand (the whole book is ~250 KB), grouped by
   topic for browsing. The grouping is only navigation; the content and its
   order are the book's (scripts/fetch-hisn.mjs). */

/** note: the narration around a duʿāʾ that was trimmed to just the words to recite (e.g. Istikhārah). */
export interface HisnDua { id: number; ar: string; tr: string; en: string; note?: string; noteTitle?: string; intro?: string; repeat: number; audio: string }
export interface HisnChapter { id: number; title: string; titleAr: string; audio: string; items: HisnDua[] }
export interface Hisn { source: string; chapters: HisnChapter[] }

let cache: Promise<Hisn> | null = null;
export const loadHisn = () => (cache ??= import('@/data/hisn.json').then((m) => m.default as Hisn));

export const ISTIKHARAH = 26;
export const MORNING_EVENING = 27;

export const GROUPS: { title: string; ids: number[] }[] = [
  { title: 'Waking, sleeping & the night', ids: [1, 28, 29, 30, 31, 32, 33] },
  { title: 'Morning & evening', ids: [27] },
  { title: 'Clothes & the home', ids: [2, 3, 4, 5, 10, 11] },
  { title: 'Purification', ids: [6, 7, 8, 9] },
  { title: 'The mosque & prayer', ids: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26] },
  { title: 'Worry, hardship & protection', ids: [34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 88, 92, 94, 122, 124, 125, 126, 128] },
  { title: 'Children, illness & death', ids: [47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 83] },
  { title: 'Weather & nature', ids: [61, 62, 63, 64, 65, 66, 67, 110, 111] },
  { title: 'Food & fasting', ids: [68, 69, 70, 71, 72, 73, 74, 75, 76] },
  { title: 'Marriage', ids: [79, 80, 81] },
  { title: 'Gatherings & manners', ids: [77, 78, 82, 84, 85, 86, 87, 89, 90, 91, 93, 106, 107, 108, 109, 112, 113, 114, 123, 132] },
  { title: 'Travel', ids: [95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105] },
  { title: 'Hajj, ʿUmrah & sacrifice', ids: [115, 116, 117, 118, 119, 120, 121, 127] },
  { title: 'Repentance & remembrance', ids: [129, 130, 131] },
];

/** Plain-text match over a chapter's title (English/Arabic) and its duʿāʾ. */
export function matches(c: HisnChapter, q: string) {
  const s = q.trim().toLowerCase();
  if (!s) return true;
  return c.title.toLowerCase().includes(s) || c.titleAr.includes(q.trim()) || c.items.some((d) => d.en.toLowerCase().includes(s) || d.tr.toLowerCase().includes(s) || d.ar.includes(q.trim()));
}
